<template>
  <div class="row mb-3 select-customer">
    <label class="col-form-label" :class="colClassLeft">Stranka</label>
    <div :class="colClassRight">
      <SelectEntity
        :required="required"
        apiEntity="DropDown/Customers"
        :modelValue="customerIDlocal"
        :canChange="canChangeCustomer"
        @update:modelValue="selectCustomer"
      />
    </div>
  </div>
  <div class="row mb-3 select-facility">
    <label class="col-form-label" :class="colClassLeft">Objekt</label>
    <div :class="colClassRight" v-if="hasCustomer">
      <SelectEntity
        :required="required"
        apiEntity="DropDown/Facilities"
        v-model="facilityIDlocal"
        :canChange="canChange"
        :filter="'?customerId=' + customerIDlocal"
        noResultsMessage="Stranka nima nobenega povezanega objekta."
      />
    </div>
    <div :class="colClassRight" v-else>Najprej izberi stranko</div>
  </div>
</template>

<script setup>
import { ref, toRef, toRefs, computed, defineComponent, watch, reactive, onMounted, inject } from "vue"
import { EMPTY_GUID } from "scripts/utils/constants"

defineOptions({ name: "SelectCustomerEntity" })

const props = defineProps({
  required: { type: Boolean, default: false },
  customerID: { type: String },
  facilityID: { type: String },
  canChange: { type: Boolean },
  canChangeCustomer: { type: Boolean, default: true },
  colClassLeft: { type: String, default: "col-sm-4" },
  colClassRight: { type: String, default: "col-sm-8" },
})

const emit = defineEmits(["change"])

const customerIDlocal = ref(EMPTY_GUID)
const facilityIDlocal = ref(EMPTY_GUID)

const customerID = toRef(props, "customerID")
const facilityID = toRef(props, "facilityID")
const canChange = toRef(props, "canChange")
const hasCustomer = computed(() => !!customerIDlocal.value && customerIDlocal.value !== EMPTY_GUID)

const emitChange = (curr, next) => {
  emit("change", {
    customerID: customerIDlocal.value,
    facilityID: facilityIDlocal.value,
  })
}

const selectCustomer = (value) => {
  const next = value ?? ""
  const changed = next !== customerIDlocal.value
  customerIDlocal.value = next
  if (changed) {
    facilityIDlocal.value = EMPTY_GUID
  }
}

watch(
  () => customerID.value,
  (curr, next) => (customerIDlocal.value = curr),
  { immediate: true },
)
watch(
  () => facilityID.value,
  (curr, next) => (facilityIDlocal.value = curr),
  { immediate: true },
)
watch(() => customerIDlocal.value, emitChange)
watch(() => facilityIDlocal.value, emitChange)
</script>
